@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 80px 0 80px 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.icon {
  margin-bottom: 46px;
  display: block;

  @include m.media(v.$container-desktop, "min") {
    display: none;
  }
}

.title {
  margin-bottom: 16px;
  @include t.text(20px, 30px, 600);
  color: v.$default-text-color;

  @include m.media(v.$container-tablet) {
    @include t.text(18px, 28px, 600);
  }
}

.subtitle {
  margin-bottom: 0;
  @include t.text(14px, 22px, 400);
  color: v.$palette-dirty-100;
  max-width: 560px;

  @include m.media(v.$container-tablet) {
    @include t.text(12px, 20px, 600);
  }
}

.actions {
  display: flex;
  gap: 8px;

  @include m.media(v.$container-tablet) {
    flex-direction: column;
  }

  .btn {
    background-color: v.$palette-orange-2;

    @include m.media(v.$container-tablet) {
      width: 296px;
    }

    &:hover {
      background-color: v.$palette-orange-3;
    }
  }
}

.hiddenInput {
  display: none;
}
